/*globals $*/
(function (BDM, newsFinder) {
    'use strict';

    var settings = {
        dataurl: "news_finder.json",
        shownumber: 12 /// Number of results to reveal initially and after load more
    },

        $el = { //stored elements
            finder: $('.news-finder'),
            filters: $('.degree-finder__filter'),
            mobileopen: $('.degree-finder__mobilebutton'),
            mobileclose: $('.degree-finder__close'),
            filterwindow: $('.degree-finder__filters'),
            results: $('.degree-finder__results'),
            template: $('.degree-finder__template .card'),
            loadmore: $('.degree-finder__loadmore'),
            tabs: $('.degree-finder__filter .nav > li'),
            select: $('.news-finder select'),
            searchField: $('#news-search'),
            searchButton: $(' .btn'),
            notfound: $('.news-finder .degree-finder__notfound'),
            loading: $('.icon__loading')
        },
        filters = [],
        results,
        reset,
        resultsLoaded = false,
        scrollPos = null,
        programData,
        searchData = [],
        useSearchData = false;

    /**
     *   Helper Methods
     **/

    function loadData() {
        var queryObject = {
            type: $('#type').val() || 'all',
            topic: $('#topic').val() || 'all',
            newsType: $('#newsType').val(),
            searchText: $el.searchField.val()
        };
        if ($el.results.hasClass('fadein')) {
            $el.results.addClass('fadeout').removeClass('fadein');
        }
        $el.loading.addClass('fadein').removeClass('fadeout');
        $.ajax({
            type: 'POST',
            url: settings.dataurl,
            data: queryObject,
            dataType: 'json',
            success: function (data) {
                if (!programData) {
                    programData = data.news;
                }
                results = data.news;
                reset = true;
                resultsLoaded = false;
                showResults();
            }
        });
    }

    function showResults() {
        var displayResults = [];
        if (resultsLoaded === false) {
            resultsLoaded = true;
            if (reset) {
                $el.results.find('.card').remove();
            }
            reset = false;
            if (results.length) {
                if (results.length > settings.shownumber) {
                    $el.loadmore.show();
                    displayResults = results.splice(0, settings.shownumber);
                } else {
                    $el.loadmore.hide();
                    displayResults = results;
                }
                $el.notfound.removeClass('fadein');
            } else {
                $el.loadmore.hide();
                if (programData) {
                    displayResults = programData.slice(0, 3);
                } else {
                    displayResults = [];
                }
                $el.notfound.addClass('fadein');
            }

            var fragment = $(document.createDocumentFragment());
            displayResults.forEach(function (result) {
                console.log('holaaaa', result);
                var path = window.location.pathname;
                var $temp = $el.template.clone();
                $temp.find('.card-body .card-title').text(result.title);
                $temp.find('.card-body .card-subtitle').text(result.subtitle);

                if (path.substr(path.lastIndexOf('/') + 0) === "/news") {
                    $temp.find('.card-subtitle').text(result.type);
                }

                $temp.find('a').attr('href', result.href);

                if (result.image) {
                    $temp.find('.card-img-top').attr('src', result.image.src);
                    $temp.find('.card-img-top').attr('alt', result.image.alt);
                } else {
                    $temp.find('.card-img-top').addClass('placeholderb');
                    $temp.find('.card-img-top').attr('src', '/images/UMassGlobal-placeholder.png');
                    $temp.find('.card-img-top').attr('alt', 'Placeholder image');
                    
                }
                if (result.icon) {
                    $temp.find('.icon').addClass(result.icon);
                } else {
                    $temp.find('.icon').remove();
                }
                fragment.append($temp);
            });

            $el.results.find(".grid-results").append(fragment);
            bindClick();

            $el.results.removeClass('fadeout').addClass('fadein');
            $el.loading.removeClass('fadein').addClass('fadeout');

            debounce(resizeHandler, 200)();
        }
    }

    function bindClick() {
        $('.degree-finder__result').off("click").on("click", function (event) {
            event.preventDefault();
            window.location.href = $(this).attr('data-href');
        });
    }

    function resizeHandler() {
        var placeholder = $el.results.find('.placeholder').first().outerHeight(),
            shortestImage = Math.max(placeholder, $el.results.find('img').first().height());
        if ($el.results.find('.card-body').length && $(window).width() > 767) {
            equalheight($el.results.find('.card-body'));
        } else {
            $el.results.find('.card-body').css('height', '');
        }
        $el.results.find('.card-img-top').not('.loaded').each(function () {
            $(this).addClass('loaded');
            if ($(this).find('img')) {
                $(this).find('img').on('load', function () {
                    debounce(resizeHandler, 200)();
                    $(this).off('load');
                });
            } else if (shortestImage > $(this).innerHeight()) {
                shortestImage = Math.max(placeholder, $(this).innerHeight());
            }
        });
        $el.results.find('.card-img-top').innerHeight(shortestImage);
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    /// Setup Events
    function bindEvents() {
        $el.loadmore.on("click", function (event) {
            event.preventDefault();
            resultsLoaded = false;
            showResults();
        });

        $el.tabs.on("click", function (event) {
            event.preventDefault();
            loadData();
        });

        $el.select.change(function (event) {
            event.preventDefault();
            loadData();
        });

        $el.mobileopen.on("click", function (event) {
            event.preventDefault();
            $el.filterwindow.addClass('open');
            $el.mobileopen.hide();
        });

        $el.mobileclose.on("click", function (event) {
            event.preventDefault();
            $el.filterwindow.removeClass('open');
            $el.mobileopen.css({ display: '' }).focus();
        });

        $el.results.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            if (resultsLoaded === false) {
                showResults();
            }
        });

        $el.searchButton.on("click", function (event) {
            event.preventDefault();
            loadData();
        });

        $el.searchField.keydown(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                loadData();
            }
        });

        $(window).resize(debounce(resizeHandler, 200));
    }

    /**
     *   Public Methods
     **/

    newsFinder.init = function () {
        if ($el.finder.length) {
            settings.dataurl = $el.finder.attr('data-programsurl') || settings.dataurl;
            scrollPos = $el.finder.offset().top;
            loadData();
            bindEvents();
        }
    };
})(window.BDM = window.BDM || {}, window.BDM.newsFinder = window.BDM.newsFinder || {});

//load when ready
$(function () {
    window.BDM.newsFinder.init();
});
